export default __webpack_public_path__ + "static/media/uno.c98a8e30.png";